import { createFileRoute } from "@tanstack/react-router";
import { UserPlus, FormInput, Database } from "lucide-react";
import { FeaturePage } from "@/components/marketing/FeaturePage";
import { alternateLinkList } from "@/lib/i18n/locale";
import heroImg from "@/assets/lead-exchange-hero.webp";
import captureImg from "@/assets/lead-exchange-capture.webp";
import flowImg from "@/assets/lead-exchange-flow.webp";

export const Route = createFileRoute("/vi/platform/networking/lead-exchange")({
  head: () => ({
    meta: [
      { title: "Form trao đổi liên hệ — banana.cards" },
      { name: "description", content: "Biến mỗi view thẻ thành lead. Form trao đổi có sẵn capture liên hệ từ ai tap thẻ." },
      { property: "og:title", content: "Form trao đổi liên hệ — banana.cards" },
      { property: "og:description", content: "Mỗi tap, một lead." },
      { property: "og:image", content: heroImg },
      { property: "og:locale", content: "vi_VN" },
    ],
    links: alternateLinkList("/platform/networking/lead-exchange", "vi"),
  }),
  component: Page,
});

function Page() {
  return (
    <FeaturePage
      eyebrow="Form trao đổi liên hệ"
      title="Mỗi tap,"
      italic="một lead."
      description="Form trao đổi có sẵn trên mọi thẻ số. Visitor để lại tên, email và số điện thoại trước khi xem hồ sơ — vào thẳng CRM."
      heroImage={heroImg}
      metrics={[{ v: "3x", l: "lead capture" }, { v: "Auto", l: "vào CRM" }, { v: "GDPR", l: "ready" }]}
      bullets={[
        { icon: FormInput, title: "Trường tùy chỉnh", desc: "Chọn trường nào bắt buộc, tùy chọn hay ẩn — tên, email, phone, công ty, ghi chú." },
        { icon: UserPlus, title: "Trao đổi 1-tap", desc: "Visitor để lại thông tin trong vài giây — và nhận lại hồ sơ đầy đủ của bạn." },
        { icon: Database, title: "Vào thẳng CRM", desc: "Mỗi lead vào Banana Contacts với nguồn, thẻ và thời điểm được tag." }
      ]}
      deepDives={[
        { eyebrow: "Capture", title: "Trao đổi liên hệ,", italic: "không phải giấy.", description: "Khi ai tap thẻ hay scan QR, form trao đổi hiện trước khi hồ sơ tiết lộ — để bạn mang đi thông tin của họ.", image: captureImg, reverse: false, points: ["Trường bắt buộc vs tùy chọn", "Form biến thể mỗi thẻ", "Intro & thank-you tùy chỉnh", "Mobile-first và accessible"] },
        { eyebrow: "Flow", title: "Từ form đến follow-up", italic: "trong 1 giây.", description: "Mỗi submission tạo contact, fire welcome email và có thể trigger automation — đổi pipeline stage, Slack ping, bất cứ gì.", image: flowImg, reverse: true, points: ["Contact tự tạo", "Welcome email tự gửi", "Trigger Banana Automation", "Webhook & Zapier"] }
      ]}
      howItWorks={[
        { title: "Thiết kế form", desc: "Chọn trường, copy và message post-submit." },
        { title: "Chia sẻ thẻ", desc: "Tap, scan hoặc gửi như thường." },
        { title: "Họ submit", desc: "Thông tin vào Banana Contacts." },
        { title: "Bạn follow up", desc: "Welcome email + automation tự fire." }
      ]}
      capabilities={["Trường tùy chỉnh mỗi thẻ", "Toggle required & optional", "Màn thank-you tùy chỉnh", "Tự tạo Banana Contact", "Welcome email tích hợp", "Webhook & Zapier", "GDPR consent ready", "Tag theo sự kiện"]}
      faq={[
        { q: "Lead Exchange là gì và vì sao nên dùng?", a: "Đảo ngược thẻ kinh doanh truyền thống: thay vì chỉ trao thông tin BẠN, thẻ yêu cầu họ để lại thông tin TRƯỚC khi xem hồ sơ. Kết quả: mỗi networking kết thúc với lead vào CRM." },
        { q: "Có thể thu thập trường nào?", a: "Standard (tên, email, phone, công ty, chức danh) + custom field không giới hạn — dropdown, multiple choice, text, date, file upload." },
        { q: "Lead vào đâu?", a: "Thẳng vào Banana CRM thành contact mới, tag theo thẻ nguồn và sự kiện." },
        { q: "Có thể tắt cho từng thẻ không?", a: "Có — Lead Exchange theo thẻ và toggle được." }
      ]}
      outro={{ title: "Đừng bao giờ rời đi", italic: "tay không.", description: "Capture lead trước khi trao thẻ." }}
    />
  );
}